import { apiFetch } from './client'
import type { LlmProvider, MeResponse } from '../types'

export const getMe = () => apiFetch<MeResponse>('me')

export const startZohoAuth = (dc: string) =>
  apiFetch<{ url: string }>('zohoAuthStart', { dc })

export const disconnectZoho = () => apiFetch<{ ok: true }>('disconnectZoho', {})

export const createPairingCode = () =>
  apiFetch<{ code: string; expiresInMs: number }>('createPairingCode', {})

export const redeemPairingCode = (code: string) =>
  apiFetch<{ token: string }>('redeemPairingCode', { code })

export const saveProviderKey = (provider: LlmProvider, key: string) =>
  apiFetch<{ ok: true; provider: LlmProvider; hint: string }>('saveProviderKey', { provider, key })

/**
 * Forget one model's key. Replies which model writes drafts afterwards, which
 * is a different one when the removed key belonged to the model in use.
 */
export const removeProviderKey = (provider: LlmProvider) =>
  apiFetch<{ ok: true; draftProvider: LlmProvider; switched: boolean }>('removeProviderKey', {
    provider,
  })

/** The agent's own name and picture. Photo is a data URL, or null to clear. */
export const saveProfile = (displayName: string, photo?: string | null) =>
  apiFetch<{ ok: true; displayName: string | null }>('saveProfile', { displayName, photo })

/** What an agent types into Settings → Send feedback. */
export const sendFeedback = (message: string) =>
  apiFetch<{ ok: true }>('sendFeedback', { message })

/** Forget this agent's own Zoho connection and API keys. */
export const resetAccount = () => apiFetch<{ ok: true }>('resetAccount', {})

/** Removes the person entirely: credentials, profile, their own uploads, sign-in. */
export const deleteMyAccount = () =>
  apiFetch<{ ok: true; documents: number }>('deleteMyAccount', {})

/** Erase the org's documents, pages, reply wording and automation. */
export const resetOrg = () =>
  apiFetch<{ ok: true; removed: number; sources: number; pages: number; files: number }>('resetOrg', {})

export const setDraftProvider = (provider: LlmProvider) =>
  apiFetch<{ ok: true; draftProvider: LlmProvider }>('setDraftProvider', { provider })

export const refreshZohoConnection = () =>
  apiFetch<{ scopes: string[]; canWrite: boolean; writeScope: string; message: string }>(
    'refreshZohoConnection',
    {},
  )
